import React, { useState, useEffect, useContext, useCallback } from "react";
import { getProducts, getFamilies } from "../api";
import { AuthContext } from "../AuthContext";
import { Blinds } from "lucide-react";

export default function ListProducts() {
  const { user } = useContext(AuthContext);
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]); // <- lista filtrada
  const [families, setFamilies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState(null);
  const [search, setSearch] = useState(""); // <- termo de busca

  const fetchProducts = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getProducts(user.token);
      setProducts(data);
      setFiltered(data); // exibe tudo inicialmente
    } catch (error) {
      setMsg({ type: "error", text: error.message });
    } finally {
      setLoading(false);
    }
  }, [user.token]);

  const fetchFamilies = useCallback(async () => {
    try {
      const data = await getFamilies(user.token);
      setFamilies(data);
    } catch (error) {
      setMsg({ type: "error", text: "Erro ao carregar famílias." });
    }
  }, [user.token]);

  // Atualiza filtragem quando usuário digita
  useEffect(() => {
    const term = search.trim().toLowerCase();
    if (!term) {
      setFiltered(products);
    } else {
      setFiltered(
        products.filter((p) =>
          p.referencia?.toLowerCase().includes(term)
        )
      );
    }
  }, [search, products]);

  useEffect(() => {
    fetchFamilies();
    fetchProducts();
  }, [fetchFamilies, fetchProducts]);

  return (
    <div className="page-container">
      <div className="dashboard-container">
        <div className="user-grid">
          <div className="user-card">
            <div className="flex items-center justify-between mb-3">
              <h3 className="flex items-center gap-2">
                <Blinds size={20} /> Produtos
              </h3>

              {msg && (
                <div
                  className={msg.type === "error" ? "error-msg" : "success-msg"}
                >
                  {msg.text}
                </div>
              )}

              {/* Campo de busca */}
              <div className="form-group">
                <input
                  type="text"
                  placeholder="Pesquisar por referência..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="outline-none text-sm"
                />
              </div>
            </div>

            <div style={{ marginBottom: "10px", fontSize: "12px", color: "#666" }}>
              Total: {products.length} | Filtrados: {filtered.length}
            </div>

            {loading ? (
              <div className="center-content">
                <div className="spinner"></div>
                <p>Carregando produtos...</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table className="user-table">
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Referência</th>
                      <th>Família</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((p) => (
                      <tr key={p.id}>
                        <td>{p.codigo}</td>
                        <td>{p.referencia}</td>
                        <td>
                          {families.find((f) => f.id === p.familia)?.familia ||
                            "-"}
                        </td>
                        <td>{p.descricao}</td>
                      </tr>
                    ))}
                    {filtered.length === 0 && (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center" }}>
                          Nenhum produto encontrado
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
